import { REQUIRED_DOCUMENTS } from './messages';

const requiredDocuments =
  (minDocuments = 1) =>
  documents => {
    const { length } = documents || [];
    if (!documents || length < minDocuments) {
      return {
        message: `${REQUIRED_DOCUMENTS}.${minDocuments > 1 ? 'many' : 'one'}`,
        minDocuments,
      };
    }
    return null;
  };

const requireMultiDocuments = shouldError => {
  return () => {
    if (!shouldError) {
      return {
        message: REQUIRED_DOCUMENTS.many,
      };
    }
    return undefined;
  };
};

const required2Documents = requiredDocuments(2);
const required1Document = requiredDocuments(1);

export { required1Document, required2Documents, requireMultiDocuments };
